import { Button,Card } from "antd";
import XLSXGeneratorDocument from "../Functions/ProjectDownloader";

export default function ProjectDownloader(props) {

    const {dataProject,Products,DiffusionProducts,Activities,UserProjectsProps}=props 
    const exportMyProjects = () => {
        XLSXGeneratorDocument.createReportProject(dataProject,Products,DiffusionProducts,Activities,UserProjectsProps);
      };

    return(
        <>
        <Card>
            <Button 
            type="primary"
            style={{
                padding:10,
                height:"100%",
                width: "100%",           
            }}
            onClick={exportMyProjects}
            >   Descagar la información</Button>
        </Card>
        </>
    )
}